import {useMediaQuery} from 'react-responsive';

const useBreakpointMD = (): boolean => useMediaQuery({minWidth: 768});

export default useBreakpointMD;
